import React from 'react'
import { connect } from 'react-redux'
import ForgetPasswordSendEmailFormComponent  from './ForgetPasswordSendEmailFormComponent'
import ForgetPasswordSendEmailConfirmComponent from './ForgetPasswordSendEmailConfirmComponent'
import { withTranslation } from 'react-i18next';

class ForgetPasswordAppImplComponent extends React.Component {
    constructor(props){
        super(props);
        this.cmeUno = props.cmeUno;
    }

    render(){
        const cmeUno = this.cmeUno;
        const page = this.props.forgetPasswordSendEmail.page;
        const {t} = this.props;
        const {readOnlyMode,readOnlyRedirectBaseUrl,env}=cmeUno.data;
        var readOnlyRedirectUrl=readOnlyRedirectBaseUrl+'/forgetpassword/form';

        if(readOnlyMode.toLowerCase()=='true') {
            return (<div>
                <h2><a href={readOnlyRedirectUrl} target="_blank">Password reset</a> is allowed only in Production environment. </h2>
                <div className="text--left">
                    <button id="backToLogin"
                            onClick={(e) => {
                                e.preventDefault();
                                window.location.href = contextPath + "/backToLogin.action";
                            }}
                            className="btn btn--secondary border--blue">{cmeUno.messages["backToLogin"]}</button>
                </div>
            </div>)
        }

        switch(page){
            case "emailSent":
                return (<ForgetPasswordSendEmailConfirmComponent cmeUno={cmeUno} />);
            default:
                return (<ForgetPasswordSendEmailFormComponent cmeUno={cmeUno} />);
        }
    }
}


const mapStateToProp = (state={}, ownProps) => ({
    forgetPasswordSendEmail: state.forgetPasswordSendEmail,
    ...ownProps
});

const ForgetPasswordSendEmailAppComponent = connect(mapStateToProp)(withTranslation()(ForgetPasswordAppImplComponent));
export default ForgetPasswordSendEmailAppComponent;